import { Label } from "./label";
import { FieldProps } from "./wrapper";

export const InfoField = ({ field }: FieldProps) => (
  <div className="border-l-4 border-neutral-400 p-[12px] pl-[16px]">
    <Label {...field} fontWeight="normal" fontSize="paragraph" />
  </div>
);
